import { useCallback } from 'react'

import ClickableListItem from 'LuxKit/List/ClickableListItem'
import type { TripListMoveDayOption } from './tripListMoveDayOptions'

interface Props {
  option: TripListMoveDayOption
  onClick: (option: TripListMoveDayOption) => void
}

function TripListMoveDayMenuItem({
  option,
  onClick,
}: Props) {
  const handleClick = useCallback(() => {
    onClick(option)
  }, [onClick, option])

  return (
    <ClickableListItem
      title={option.title}
      subtitle={option.subtitle}
      size="large"
      selected={option.selected}
      onClick={handleClick}
    />
  )
}

export default TripListMoveDayMenuItem
